var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
function SvgToggleOn(passedProps, svgRef) {
    var props = __assign({}, passedProps);
    return (React.createElement("svg", __assign({ width: "1.5em", height: "1.5em", viewBox: "0 0 31 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", color: "currentColor", ref: svgRef }, props),
        React.createElement("path", { d: "M11.404 5.605c-3.75 0-6.75 3.047-6.75 6.75 0 3.75 3 6.75 6.75 6.75h9c3.703 0 6.75-3 6.75-6.75 0-3.703-3.047-6.75-6.75-6.75h-9zm-9 6.75c0-4.968 4.032-9 9-9h9c4.969 0 9 4.032 9 9 0 4.97-4.031 9-9 9h-9c-4.968 0-9-4.03-9-9zm18-4.5c1.594 0 3.047.891 3.89 2.25.798 1.407.798 3.141 0 4.5-.843 1.407-2.296 2.25-3.89 2.25-1.64 0-3.093-.843-3.937-2.25-.797-1.359-.797-3.093 0-4.5.844-1.359 2.297-2.25 3.937-2.25z", fill: "#242B42" })));
}
var ForwardRef = React.forwardRef(SvgToggleOn);
export default ForwardRef;
